import React from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import LoginModal from '../components/Modals/LoginModal';

const AuthPage = () => {
    const [searchParams] = useSearchParams();
    const navigate = useNavigate();
    const returnTo = searchParams.get('returnTo') || '/';

    const handleCloseModal = () => {
        // На странице авторизации НЕ позволяем закрыть модальное окно
        // Пользователь должен авторизоваться чтобы продолжить
        console.log('🔐 AuthPage: Попытка закрыть модальное окно заблокирована');
        return;
    };

    const handleAuthSuccess = () => {
        // При успешной авторизации возвращаемся на исходную страницу
        navigate(returnTo);
    };

    console.log('🔐 AuthPage: Страница авторизации загружена');
    console.log('🔐 AuthPage: Возврат на страницу:', returnTo);

    return (
        <div className="min-h-screen bg-gradient-to-br from-blue-500 to-purple-600 flex items-center justify-center p-4">
            <div className="w-full max-w-md">
                <div className="text-center mb-8">
                    <div className="text-4xl mb-4">🔐</div>
                    <h1 className="text-2xl font-bold text-white mb-2">
                        Авторизация
                    </h1>
                </div>
                
                <LoginModal 
                    isOpen={true} 
                    onClose={handleCloseModal}
                    onAuthSuccess={handleAuthSuccess}
                    isAuthPage={true} // Передаем флаг что это страница авторизации
                />
            </div>
        </div>
    );
};

export default AuthPage;
